export default "__VITE_ASSET__DQQdlZ4x__"